import React from 'react';
import { CheckIcon, XIcon } from '../common/IconsComponent';

// ─── Helpers ─────────────────────────────────────────────────────────────────

const allTrue  = (arr) => arr.every(Boolean);
const someTrue = (arr) => arr.some(Boolean);

const DayState = ({ slots }) => {
  if (allTrue(slots))  return <CheckIcon size={14} className="text-green-600" />;
  if (someTrue(slots)) return <div className="w-2.5 h-2.5 bg-green-500 rounded-sm" />;
  return <XIcon size={14} className="text-red-500" />;
};

const TimeState = ({ availability, timeIndex }) => {
  const col = availability.map((day) => day[timeIndex]);
  if (allTrue(col))  return <CheckIcon size={14} className="text-green-600" />;
  if (someTrue(col)) return <div className="w-2.5 h-2.5 bg-green-500 rounded-sm" />;
  return <XIcon size={14} className="text-red-500" />;
};

// ─── Component ───────────────────────────────────────────────────────────────

const AvailabilityScheduler = ({
  daysOfWeek, timeSlots, availability,
  toggleCell, toggleDay, toggleTime, toggleAll,
}) => {
  const allSelected = availability.flat().every(Boolean);

  return (
    <div className="overflow-x-auto">
      <table className="w-full border-collapse text-sm">
        <thead>
          <tr>
            {/* Top-right corner */}
            <th className="p-2 bg-amber-500 text-white text-right min-w-[90px] sm:min-w-[110px]">
              <span className="block mb-1 text-xs sm:text-sm">שעות</span>
              <button
                type="button"
                onClick={toggleAll}
                className="text-xs bg-white text-amber-600 px-2 py-0.5 rounded hover:bg-amber-50 transition-colors whitespace-nowrap"
              >
                {allSelected ? 'נקה הכל' : 'בחר הכל'}
              </button>
            </th>

            {/* Day headers */}
            {daysOfWeek.map((day, dayIndex) => (
              <th
                key={day}
                onClick={() => toggleDay(dayIndex)}
                className="p-1.5 sm:p-2 bg-amber-200 cursor-pointer min-w-[36px] sm:min-w-[48px]"
              >
                <div className="flex flex-col items-center gap-1">
                  <span className="font-bold text-xs sm:text-sm">{day}</span>
                  <div className="flex items-center justify-center w-4 h-4">
                    <DayState slots={availability[dayIndex]} />
                  </div>
                </div>
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          {timeSlots.map((slot, timeIndex) => (
            <tr key={`${slot.start}-${slot.end}`}>
              {/* Time label */}
              <td
                onClick={() => toggleTime(timeIndex)}
                className="p-1.5 sm:p-2 bg-blue-100 text-right cursor-pointer"
              >
                <div className="flex items-center justify-between gap-2">
                  <div className="flex items-center justify-center w-4 h-4 flex-shrink-0">
                    <TimeState availability={availability} timeIndex={timeIndex} />
                  </div>
                  <span className="text-xs sm:text-sm whitespace-nowrap tabular-nums">
                    {slot.end} – {slot.start}
                  </span>
                </div>
              </td>

              {/* Cells */}
              {daysOfWeek.map((_, dayIndex) => {
                const active = availability[dayIndex][timeIndex];
                return (
                  <td
                    key={`${dayIndex}-${timeIndex}`}
                    onClick={() => toggleCell(dayIndex, timeIndex)}
                    className={`border border-gray-200 cursor-pointer transition-colors ${
                      active ? 'bg-green-200 hover:bg-green-300' : 'bg-orange-200 hover:bg-orange-300'
                    }`}
                  >
                    {active && (
                      <div className="flex items-center justify-center p-1 sm:p-2">
                        <CheckIcon size={14} className="text-green-600" />
                      </div>
                    )}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AvailabilityScheduler;